<div style="font-size: 12px; width: 100%;">
    <div class="panel-body">
        <div class="row my-4">
        <div class="col-md-3">
            <div class="searchInputGroup">
            <div class="searchIcon">
                <img src="../images/new_ui/filter.png">
            </div>
            <input class="searchInput" type="text" placeholder="Filter" [(ngModel)]="endUserSearchStr">
            </div>
        </div>
        </div>

        <div class="shared-outer-wrapper">
        <table class="table mb-0">
            <thead>
            <tr>
                <th scope="col" style="width:5%;"></th>
                <th scope="col" style="width:20%;" class="align-left">UserName</th>
                <th scope="col" style="width:35%;" class="align-left">Email</th>
                <th scope="col" style="width:20%;" class="align-left"></th>
                <th scope="col" style="width:20%;"></th>
            </tr>
            </thead>
            <tbody>
            <ng-container *ngFor="let user of tenantUsers;index as i">

                <ng-container *ngIf="filterEndUser(user)">
                <tr>
                    <td></td>
                    <td class="align-left">{{user.displayName}}</td>
                    <td class="align-left">{{user.userPrincipalName}}</td>
                    <td class="align-center">
                    <span id="delete-icon" class="basic-icon delete-icon" (click)="removeEndUser(user)"
                        ngbTooltip="Remove" placement="bottom"></span>
                    </td>
                    <td></td>
                </tr>

                </ng-container>
            </ng-container>

            </tbody>
        </table>
        </div>

        <div class="col align-center confirmbtn my-3">
        <!-- <button *ngIf="!isStaffAccount" class="button button-red button-large btn-long" (click)="configurePortal()">Configure
            Portal</button> -->
        <button class="button button-red button-large btn-long" (click)="configurePortalV1()">Configure
            Portal</button>
        <button class="button button-red button-large btn-long" (click)="configureEnduser()">Configure
            Users</button>
        </div>
    </div>
</div>